import { ListUserDto } from "./user.models";
import { ListLocationDto } from "./location.models";
import { ListCategoryDto } from "./categories.models";
import { ListPriorityDto } from "./priority.models";
import { ListTeamDto } from "./team.models";
import { ListFileDto } from "./file.models";
import { ListAssetDto } from "./assets.models";
import { ListVendorDto } from "./vendors.models";
import { EventDto } from "./event.models";

export interface ListWorkOrderDto {
	WorkOrderId: string;
	WorkOrderNumber: string;
	Title: string;
	Status: WorkOrderStatus;
	Priority: ListPriorityDto;
	Location: ListLocationDto;
	Categories: ListCategoryDto[];
	Assets: ListAssetDto[];
	Vendors: ListVendorDto[];
	AssignedTo?: WorkOrderAssignmentsDto;
	StartedDate?: Date;
	DueDate?: Date;
	CompletedDate?: Date;
	Read: boolean;
	Created: Date;
	CreatedBy: ListUserDto;
	Updated?: Date;
	UpdatedBy: ListUserDto | null;
	Deleted?: Date;
	DeletedBy: ListUserDto | null;
}

export interface WorkOrderDto {
	WorkOrderId: string;
	WorkOrderNumber: string;
	Title: string;
	Description?: string;
	Status: WorkOrderStatus;
	Priority: ListPriorityDto;
	Location: ListLocationDto;
	Categories: ListCategoryDto[];
	Assets: ListAssetDto[];
	Vendors: ListVendorDto[];
	AssignedTo?: WorkOrderAssignmentsDto;
	Files: ListFileDto[];
	StartedDate?: Date;
	DueDate?: Date;
	CompletedDate?: Date;
	Created: Date;
	CreatedBy: ListUserDto;
	Updated: Date | null;
	UpdatedBy: ListUserDto | null;
	Deleted: Date | null;
	DeletedBy: ListUserDto | null;
	Events: EventDto[];
}

export interface WorkOrderAssignmentsDto {
	Users: ListUserDto[];
	Teams: ListTeamDto[];
}

export interface MutableWorkOrderDto {
	WorkOrderId: string;
	WorkOrderTemplateId?: string;
	Title: string;
	Description?: string;
	Status: WorkOrderStatus;
	Priority: string;
	StartedDate?: Date | null;
	DueDate?: Date | null;
	Location: string;
	Categories: string[];
	Assets: string[];
	Vendors: string[];
	AssignedTo?: string[];
	FilesToDelete?: string[];
}

export interface SendWorkOrderEmailDto {
	UserIds: string[];
	TeamIds: string[];
	CustomEmails: string[];
}

export enum WorkOrderStatus {
	None = -1,
	Requested = 0,
	Open = 1,
	OnHold = 2,
	InProgress = 3,
	Completed = 4,
	Archived = 5
}